import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, ref, watch } from '@nuxtjs/composition-api';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import {
  SanityImageObject,
  SanityReference,
} from '@sanity/image-url/lib/types/types';
import { useSanityDocument } from '~/composables/useSanityDocument';

interface Prize {
  doc: ReturnType<typeof useSanityDocument>['doc'];
  isLoading: ReturnType<typeof useSanityDocument>['isLoading'];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectPrizesGrid',
  props: {
    prizes: null,
    headline: null
  },
  setup(__props: any) {

const props = __props as {
  prizes: SanityReference[];
  headline?: string;
};

const { $vuetify, $sanityImage } = useContext();



const prizeRefs = ref<Prize[]>([]);

const getImageUrl = (image: SanityImageObject) => {
  return $sanityImage.urlFor(image.asset?._ref).url();
};

function fetchPrizeDocuments() {
  prizeRefs.value = props.prizes.map((prize) => {
    const { doc, isLoading } = useSanityDocument<
      ISanityDocuments[SanityDocumentSchema.PROJECT_PRIZE]
    >(
      computed(() => ({
        _id: prize._ref,
        _type: SanityDocumentSchema.PROJECT_PRIZE,
      })),
    );

    return {
      doc,
      isLoading,
    };
  });
}

fetchPrizeDocuments();

watch(
  () => props.prizes,
  (newRefs) => {
    fetchPrizeDocuments();
  },
  { deep: true },
);

return { __sfc: true,$vuetify, $sanityImage, props, prizeRefs, getImageUrl, fetchPrizeDocuments }
}

})